export default __webpack_public_path__ + "static/media/betSlipBg.2f193d54.png";